import React, { ReactNode, createContext, useContext } from 'react';
import { setCookie, getCookie, removeCookie } from './CookieService';
import Cookies from 'js-cookie';

interface CookieContextType {
    setCookie: (name: string, value: object, options?: Cookies.CookieAttributes) => void;
    getCookie: (name: string) => string | object | undefined;
    removeCookie: (name: string, options?: Cookies.CookieAttributes) => void;
}

const CookieContext = createContext<CookieContextType>({
    setCookie: () => { },
    getCookie: () => undefined,
    removeCookie: () => { },
});

export const useCookies = () => useContext(CookieContext);

interface CookieProviderProps {
    children: ReactNode;
}

export const CookieProvider: React.FC<CookieProviderProps> = ({ children }) => {
    const setCookie = (name: string, value: string | object, options?: Cookies.CookieAttributes) => {
        try {
            const serializedValue = typeof value === 'object' ? JSON.stringify(value) : value;
            Cookies.set(name, serializedValue, options);
        } catch (error) {
            console.log("🚀 ~ setCookie ~ error:", error)
        }
    };

    const getCookie = (name: string) => {
        const value = Cookies.get(name);
        try {
            return value ? JSON.parse(value) : undefined;
        } catch {
            return value;
        }
    };

    const removeCookie = (name: string, options?: Cookies.CookieAttributes) => {
        Cookies.remove(name, options);
    };

    return (
        <CookieContext.Provider value={{ setCookie, getCookie, removeCookie }}>
            {children}
        </CookieContext.Provider>
    );
};